import MetaTags from "./index";

const tags = {
  all: {
    vod: {
      title: "人気月額商品を動画で配信中！ | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,月額商品,月額商品一覧,スカパー！",
      description:
        "SPOOX(スプークス)で配信中の月額商品一覧。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど様々な月額商品の作品を配信中です。",
      og: { type: "article" },
    },
  },
  entitled: {
    vod: {
      title: "契約中の月額商品一覧 | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,月額商品,月額商品一覧,スカパー！",
      description:
        "契約中の月額商品一覧。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど様々な月額商品の作品を配信中です。",
      og: { type: "article" },
    },
  },
  unentitled: {
    vod: {
      title: "未契約の月額商品一覧 | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,月額商品,月額商品一覧,スカパー！",
      description:
        "未契約の月額商品一覧。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど様々な月額商品の作品を配信中です。",
      og: { type: "article" },
    },
  },
};

export default function ChannelsMetaTags({ mode }) {
  const props = tags[mode]["vod"];

  return <MetaTags {...props} />;
}
